import BeloningCreator from "../../componants/belongings/BelongingCreator";

function AddBelonging(){
    return(
        <BeloningCreator>
            
        </BeloningCreator>
    )
}

export default AddBelonging;